import React, { useCallback } from 'react'
import { Text } from '@usap/uicomponents'
import {
    OrderDetailsButtonContainer,
    OrderDetailsCtaWmo
} from './style/buttonWMO.css'

const BuyItAgainButtonWMO = ({ productUri, itemStatus, isDesktop, gtmBuyAgainClick }) => {

    const clickHandler = () => {
        gtmBuyAgainClick();
        window.location.href = `/${productUri}`;
    }

    return (
        productUri && itemStatus != 'Canceled' && itemStatus != 'Cancelled' ?
            (
                <OrderDetailsButtonContainer>
                    <OrderDetailsCtaWmo
                        custom
                        hideBorder
                        label={<Text size={isDesktop ? '16px' : '14px'} color={'dark-2'}>Buy It Again</Text>}
                        onClick={clickHandler}
                    />
                </OrderDetailsButtonContainer>
            )
            :
            null
    )
}

export default BuyItAgainButtonWMO
